import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { API_URL, URLS } from "../../_config";
import { useToken, useUser } from "../../_common/hooks/authHook";
import toast from "react-hot-toast"; 
import { useNavigate } from "react-router-dom";
import { buttonStyles, CARD_ELEMENT_OPTIONS, errorStyles, formStyles, inputWrapperStyles, labelStyles } from "./CheckoutFormStyleOptions";

const CheckoutForm = ({ propData, onProcessingChange }: any) => {
  const stripe: any = useStripe();
  const elements: any = useElements();
  const userData: any = useUser();
  const tokenData: any = useToken();
  const [error, setError] = useState<string | null>(null);
  const [processing, setProcessing] = useState(false);
  const navigate: any = useNavigate();

  console.log('propData====================', propData);
  const submitPayment = () => {
    return new Promise((resolve, reject) => {
      if (!stripe || !elements) {
        reject("Stripe has not loaded yet. Please try again.");
        return;
      }
      setProcessing(true);
      onProcessingChange?.(true);

      // Validate that we have a valid client secret before proceeding
      if (!propData?.clientSecret) {
        setProcessing(false);
        onProcessingChange?.(false);
        reject("Payment session has expired or is invalid. Please refresh and try again.");
        return;
      }

      const cardElement = elements.getElement(CardElement);
      stripe
        .confirmCardPayment(propData?.clientSecret, {
          payment_method: {
            card: cardElement,
            billing_details: {
              name: userData?.full_name,
              email: userData?.email,
            },
          },
        })
        .then((result: { error?: { message: string; code?: string }; paymentIntent?: { status: string; amount: number; currency: string; id: string; payment_method: string; payment_method_types: string[] } }) => {
          if (result.error) {
            const errorMessage = result.error.message;
            if (result.error.code === "resource_missing") {
              toast.error("The payment session has expired. Please refresh the page and try again.");
            } else if (result.error.code === "payment_intent_unexpected_state") {
              toast.error("The payment intent is in an unexpected state. Please contact support.");
            } else {
              toast.error(errorMessage);
            }
            console.error("Stripe error:", result.error);
            setError(errorMessage);
            setProcessing(false);
            onProcessingChange?.(false);
            reject(errorMessage);
          } else if (result.paymentIntent?.status === "succeeded") {
            setProcessing(false);
            // onProcessingChange?.(false);
            setError(null);
            resolve("Payment successful");

            const params = {
              status: result.paymentIntent.status,
              proposal_id: propData?.paymentProposalId,
              amount: result.paymentIntent.amount,
              currency: result.paymentIntent.currency,
              transaction_id: result.paymentIntent.id,
              payment_method: result.paymentIntent.payment_method,
              payment_method_types: result.paymentIntent.payment_method_types,
              return_data: JSON.stringify(result),
              payment_type: "Stripe",
              transaction_date: new Date().toISOString(),
              discount_amount: propData?.discountAmount ?? 0,
            };

            fetch(API_URL.PAYMENTS.STRIPE_PAYMENT_STORE, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
              body: JSON.stringify(params),
            })
              .then((response) => response.json())
              .then((resp) => {
                if (resp?.status === 200) {
                  onProcessingChange?.(false);
                  resolve(resp.message);
                  navigate(URLS.ACCOUNT.PAYMENT.THANK_YOU);
                } else {
                  setError(resp?.message);
                  reject(resp.message);
                  setProcessing(false);
                  onProcessingChange?.(false);
                }
              })
              .catch((error: any) => {
                console.error("Payment API error:", error);
                const errorMsg = error?.message || "Payment verification failed. Please contact support.";
                setError(errorMsg);
                reject(errorMsg);
                setProcessing(false);
                onProcessingChange?.(false);
              });
          }
        })
        .catch((error: any) => {
          console.error("Stripe confirmation error:", error);
          const errorMsg = error?.message || "An unexpected error occurred. Please try again.";
          setError(errorMsg);
          setProcessing(false);
          onProcessingChange?.(false);
          reject(errorMsg);
        });
    });
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    
    // Verify we have the required data before proceeding
    if (!propData?.clientSecret) {
      toast.error("Payment session has expired. Please refresh the page.");
      return;
    }
    
    toast.promise(
      submitPayment(), {
      loading: 'Processing payment...',
      success: (msg: any) => {
        return <b>{msg}</b>
      },
      error: (msg: any) => { return <b>{msg}</b> },
    });

  };


  return (
    <form onSubmit={handleSubmit} className="checkout-form" style={formStyles}>

      <div style={{ marginBottom: '20px' }}>
        <label htmlFor="card-element" style={labelStyles}>
          Credit or Debit Card
        </label>
        <div style={inputWrapperStyles}>
          <CardElement id="card-element" className="card-element"
            options={CARD_ELEMENT_OPTIONS}
          />
        </div>
        {error && <p style={errorStyles}>{error}</p>}
      </div>

      {/* <button type="submit" className="stripePay submit-button" style={buttonStyles} disabled={!stripe || processing}>
        {processing ? 'Processing...' : `Pay Now`}
      </button> */}
      <button type="submit" style={buttonStyles} disabled={!stripe}>
        Pay  {(propData.paymentAmount / 100).toFixed(2)} {propData?.currency.toUpperCase()}
      </button>
    </form>
  );
};

export default CheckoutForm;
